import { render, staticRenderFns } from "./SpendDashboard.vue?vue&type=template&id=0206172f&scoped=true&"
import script from "./SpendDashboard.vue?vue&type=script&lang=js&"
export * from "./SpendDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SpendDashboard.vue?vue&type=style&index=0&id=0206172f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0206172f",
  null
  
)

export default component.exports